// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coming-soon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  padding: 2rem;
}

.coming-soon-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 600px;
  width: 100%;
}

.coming-soon-title {
  font-size: 32px;
  font-weight: 700;
  color: #1a1919;
  font-family: "Lato", sans-serif;
  margin-bottom: 1.5rem;
  letter-spacing: 0px;
}

.coming-soon-subtitle {
  font-size: 20px;
  color: #374151;
  font-family: "Lato", sans-serif;
  margin-bottom: 2.5rem;
  line-height: 1.6;
  letter-spacing: 0px;
}

.coming-soon-button {
  margin-top: 1rem;
  text-align: center;
  font-family: "Lato", sans-serif;
  letter-spacing: 0px;
  background-color: rgb(120, 204, 210);
  border-radius: 1rem;
  padding: 1rem 3rem;
  height: auto;
  min-height: 3rem;
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 18px;
  font-weight: 700;
  color: #1a1919;
  opacity: 1;
  border: none;
  transition: all 0.3s ease;
}

.coming-soon-button:hover {
  background-color: rgb(100, 184, 190);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.coming-soon-button:active {
  transform: translateY(0);
}

@media (max-width: 992px) {
  .coming-soon-title {
    font-size: 28px;
  }
  .coming-soon-subtitle {
    font-size: 18px;
  }
  .coming-soon-button {
    font-size: 16px;
  }
}

@media (max-width: 768px) {
  .coming-soon-container {
    min-height: 50vh;
    padding: 1.5rem;
  }
  .coming-soon-title {
    font-size: 24px;
    margin-bottom: 1rem;
  }
  .coming-soon-subtitle {
    font-size: 16px;
    margin-bottom: 2rem;
  }
  .coming-soon-button {
    font-size: 15px;
    padding: 0.65rem 1.5rem;
  }
}

@media (max-width: 576px) {
  .coming-soon-title {
    font-size: 22px;
  }
  .coming-soon-subtitle {
    font-size: 14px;
  }
  .coming-soon-button {
    font-size: 14px;
    padding: 0.6rem 1.25rem;
  }
}
/*# sourceMappingURL=comingSoon.css.map */
`, "",{"version":3,"sources":["webpack://./src/sass/views/comingSoon.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,+BAA+B;EAC/B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,uBAAuB;EACzB;AACF;AACA,yCAAyC","sourcesContent":[".coming-soon-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 60vh;\n  padding: 2rem;\n}\n\n.coming-soon-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  max-width: 600px;\n  width: 100%;\n}\n\n.coming-soon-title {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1a1919;\n  font-family: \"Lato\", sans-serif;\n  margin-bottom: 1.5rem;\n  letter-spacing: 0px;\n}\n\n.coming-soon-subtitle {\n  font-size: 20px;\n  color: #374151;\n  font-family: \"Lato\", sans-serif;\n  margin-bottom: 2.5rem;\n  line-height: 1.6;\n  letter-spacing: 0px;\n}\n\n.coming-soon-button {\n  margin-top: 1rem;\n  text-align: center;\n  font-family: \"Lato\", sans-serif;\n  letter-spacing: 0px;\n  background-color: rgb(120, 204, 210);\n  border-radius: 1rem;\n  padding: 1rem 3rem;\n  height: auto;\n  min-height: 3rem;\n  width: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  font-size: 18px;\n  font-weight: 700;\n  color: #1a1919;\n  opacity: 1;\n  border: none;\n  transition: all 0.3s ease;\n}\n\n.coming-soon-button:hover {\n  background-color: rgb(100, 184, 190);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.coming-soon-button:active {\n  transform: translateY(0);\n}\n\n@media (max-width: 992px) {\n  .coming-soon-title {\n    font-size: 28px;\n  }\n  .coming-soon-subtitle {\n    font-size: 18px;\n  }\n  .coming-soon-button {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 768px) {\n  .coming-soon-container {\n    min-height: 50vh;\n    padding: 1.5rem;\n  }\n  .coming-soon-title {\n    font-size: 24px;\n    margin-bottom: 1rem;\n  }\n  .coming-soon-subtitle {\n    font-size: 16px;\n    margin-bottom: 2rem;\n  }\n  .coming-soon-button {\n    font-size: 15px;\n    padding: 0.65rem 1.5rem;\n  }\n}\n\n@media (max-width: 576px) {\n  .coming-soon-title {\n    font-size: 22px;\n  }\n  .coming-soon-subtitle {\n    font-size: 14px;\n  }\n  .coming-soon-button {\n    font-size: 14px;\n    padding: 0.6rem 1.25rem;\n  }\n}\n/*# sourceMappingURL=comingSoon.css.map */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
